<script>
  export let img;
  export let imgHover;
  export let text;
  export let onClick;

  let hover = false;

  let setHover = (isHover) => {
    hover = isHover;
  };
</script>

<div
  class="contextMenuItem"
  on:click={onClick}
  on:mouseenter={() => setHover(true)}
  on:mouseleave={() => setHover(false)}
>
  <img class={hover ? "hiddenElement" : ""} src={img} alt="Hide Bar" />
  <img class={hover ? "" : "hiddenElement"} src={imgHover} alt="Hide Bar" />
  <span>{text}</span>
</div>

<style>
  div.contextMenuItem {
    padding: 5px;
    font-size: 13px;
    color: var(--labit-card-gray);
    background-color: var(--labit-dialog-background);
    cursor: pointer;
    min-width: 135px;
  }

  div.contextMenuItem:first-child {
    border-radius: 5px 5px 0px 0px;
  }

  div.contextMenuItem:last-child {
    border-radius: 0px 0px 5px 5px;
  }

  div.contextMenuItem:hover {
    background-color: var(--labit-card-gray);
    color: var(--labit-dialog-background);
  }

  div.contextMenuItem img {
    width: 10px;
    margin: 0px 5px 0px 0px;
  }
</style>
